/* eslint-disable import/no-anonymous-default-export */
export default {
  common: {
    signOut: "Sign out",
    bulkActions: "Bulk Actions",
    actionConfirm: "Action Confirmation",
    keywordSearch: "Type Keyword to Search",
    actions: "Actions",
    add: "Add",
    alert: "Alert",
    none: "None",
    warn: "Warning",
    gotIt: "Got it",
    menu: "Menu",
    section: "Section",
    module: "Module",
    field: "Field",
    recordId: "Record ID",
    timestamp: "Timestamp",
    version: "Version",
    lcm: "LCM",
    previousValue: "Previous Value",
    addButtonText: "Add {{moduleName}}",
    editButtonText: "Edit {{moduleName}}",
    viewButtonText: "View {{moduleName}}",
    warning: "Warning",
    edit: "Edit",
    discard: "Discard",
    view: "View",
    status: "Status",
    tag: "Tag",
    collapseMenu: "Collapse Menu",
    expandMenu: "Expand Menu",
    save: "Save",
    saveDraft: "Save Draft",
    saveAndClose: "Save & Close",
    saveAndNext: "Save & Next",
    saveAndFinish: "Save and Finish",
    cancel: "Cancel",
    delete: "Delete",
    viewChanges: "View Changes",
    update: "Update",
    newStage: "New Stage",
    lifecycleStage: 'Lifecycle Stage',
    regulatoryStatus: "Regulatory Status",
    noSet: "Not Set",
    current: "Current",
    lifeCycleUpdate: "Update LifeCycle Stage",
    deleteConfirmMsg: "Are you sure you want to delete?",
    disableRecordConfirm: "Are you sure you want to make the record disabled?",
    cancelConfirm:
      "Any unsaved changes made will be lost. Do you wish to continue?",
    no: "No",
    yes: "Yes",
    stage: "Stage",
    draft: "Draft",
    comments: "Comments",
    approved: "Approved",
    linkRecord: "Linked Records",
    // lifeCycleUpdate: "LifeCycle Update",
    next: "Next",
    continue: "Continue",
    continueAndSave: "Continue and Save",
    noDataAvailable: "No Data Available",
    noResults: "No results found.",
    reason: "Reason",
    createdBy: "Created By",
    modifiedBy: "Modified By",
    createdby: "Created by",
    lastModifiedBy: "Last Modified by",
    userOnDate:'{{user}} on {{date}}',
    saveChanges: "Save Changes",
    close: "Close",
    pleaseEnter: "Please Enter...",
    globalSmartSearch: "Global Smart Search",
    loadingText: "We are loading the data for you. Please wait.",
    collapse: "Collapse",
    expand: "Expand",
    search: "Search",
    paracetamol: "paracetamol",
    clone: "Clone",
    cloneRecordConfirm:
      "Are you sure you want to clone this record?",
    cloneConfirmButton: "Confirm",
    cloneTaskInProgress:
      "Clone task is in progress. Please wait and do not leave this page.",
    cloneSuccessMessage: "The record cloned successfully.",
    cloneTaskTimeout: "Clone task timed out. Please try again.",
    cloneCreateFailed: "Failed to start clone task.",
    cloneTaskStatusQueryFailed:
      "Failed to get clone task status. Retrying...",
    disable: "Disable",
    enable: "Enable",
    manageWorkflow: "Manage Workflow",
    publish: "Publish",
    saveAsDocument: "Save As Document",
    preview: "Preview",
    download: "Download",
    summarizeIt: "Summarize It",
    translateDocument: "Translate Document",
    submit: "Submit",
    languageSwitch: "Language Switch",
    tokenIsExpired: "Your token is expired, please login again",
    inactive: "Inactive",
    user: "User",
    downloadExcel: "Download as Excel",
    downloadCSV: "Download as CSV",
    downloadPDF: "Download as PDF",
    copyLink: "Copy Link",
    copyLinkSuccess: "Link copied to clipboard",
    copyLinkFailed: "Failed to copy link",
    typeofAssociation: "Type of Association",
    recordName: "Record Name",
    previous: "Previous",
    finish: "Finish",
    noAccess: "No Access",
    confirmationDialogTitle: "Action Confirmation",
    tip: {
      commonErrorMessage:
        "There is something wrong with server, please try again later",
      noPrivileges: "You have no privileges",
      addSuccessWithName: "{{moduleName}} created successfully.",
      addFailedWithName: "{{moduleName}} created failed.",
      fieldRequired: "{{fieldName}} is required",
      fieldSelectPlaceholder: "Select the {{fieldName}}",
      addSuccess: "Add successfully.",
      addFailed: "Add failed.",
      cancelAdd: "Are you sure you want to cancel? All your data will be lost.",
      updateSuccess: "Update successfully.",
      updateFailed: "Update failed.",
      packageDataHierarchyNotContinuous:
        "Save blocked. The selected Package Data hierarchy is not continuous. Please select the missing intermediate level(s): {{details}}.",
      packageDataHierarchyNotContinuousDetail:
        "{{path}} (missing: {{missing}})",
      updateSuccessWithName: "{{moduleName}} updated successfully.",
      updateFailedWithName: "{{moduleName}} updated failed.",
      revertSuccess: "Revert successfully.",
      revertFailed: "Revert failed.",
      deleteSuccess: "Delete successfully.",
      deleteFailed: "Delete failed.",
      deleteSuccessWithName: "{{moduleName}} deleted successfully.",
      deleteFailedWithName: "{{moduleName}} deleted failed.",
      deletion: "Please enter a reason for deletion.",
      limit_2000: "The input exceeds the maximum limit of 2,000 characters.",
      selectOneItem: "Please select one item.",
      selectTarget: "Please select target first.",
      disableSuccess: "Disabled the record successfully.",
      disableFailed: "Disabled the record failed.",
      continueConfirm: "Would you like to continue?",
    },
    identifiers: {
      title: "Manage Identifiers",
      updateSuccessTip: "Update successfully.",
      updateSuccessTipWithNumber: "{{successCount}} out of {{allCount}} record(s) updated successfully!",
    },
    dialog: {
      historyVersionTitle: "Historical Version of {{recordId}}",
      recordIdNote:
      "This record is currently being used in other records. Are you sure you want to proceed?",
      title: "Field Configuration Validation",
      deleteRecordId: "Record <bold>cannot be deleted</bold> because it has the below dependencies:",
      shouldBe: " should be ",
      dependsOn: " depends on ",
      inScope: " in the scope of ",
      deleteValue: 'Delete the value of <bold>{{fieldName}}</bold>.',
      changeValueTo: 'Change the value of <bold>{{fieldName}}</bold> to',
      changeValueToDependsOn: 'Change the value of <bold>{{fieldName}}</bold> to {{newValue}} is not allowed, because: ',
      compareCurrentDateMessage: 'The value of <bold>{{fieldName}}</bold> should be {{rule}} the Current Date.',
      subUpdateValidationTxt: 'Based on the Configuration Manager, the value of <bold>{{fieldName}}</bold> will be automatically set to the value of <bold>{{linkFieldName}}</bold>.',
      compareValdationMessage: 'The value of <bold>{{fieldName}}</bold> should be {{rule}} the value of <bold>{{childName}}</bold>{{childValue}}.',
      inScopeValidationMessage: 'The value of <bold>{{fieldName}}</bold> should be {{rule}} <bold>{{childName}}</bold>{{childValue}}.',
      mandatoryValidationMesssage: 'The value of <bold>{{fieldName}}</bold> should not be empty.',
      childCompareValidationMessage: '<bold>{{childLinkField}}</bold> should be {{message}}.',
      isRequired: '<bold>{{fieldName}}</bold> is Required.',
      min: 'The value of <bold>{{fieldName}}</bold> must be at least {{value}}.',
      max: 'The value of <bold>{{fieldName}}</bold> cannot exceed {{value}}.',
      minLength: 'The value of <bold>{{fieldName}}</bold> must be at least {{value}} characters.',
      maxLength: 'The value of <bold>{{fieldName}}</bold> cannot be longer than {{value}} characters.',
      minDate: 'The value of <bold>{{fieldName}}</bold> cannot be before {{value}}.',
      maxDate: 'The value of <bold>{{fieldName}}</bold> cannot be after {{value}}.',
      dependencyExistMesssage: '<bold>{{fieldName}}</bold> should not be empty.',
      regularMessage: 'The value of <bold>{{fieldName}}</bold> should match the pattern: {{value}}.',
      empty: 'empty.',
      emptyNoDot: 'empty',
    }
  },
  actions: {
    historicalVersions: "Historical Versions"
  },
  product: {
    products: "Products",
    addProduct: "Add Product",
    editProduct: "Edit Product",
    productNameTooltip: "Name of product",
    productTypeTooltip: "Type of product",
    productFamilyCodeTooltip: "Product Family Code: OG-xxxx",
    activeIngredientSubstance: "Active Ingredient/Substance",
    strength: "Strength",
    strengthUnit: "Strength Unit",
    dosageForm: "Dosage Form",
    basicInformation: "Basic Information",
    routeOfAdmin: "Route of Admin",
    tradeName: "Trade Name",
    genericNameOrFamilyName: "Generic Name/Family Name",
    countryGroup: "Country Group",
    country: "Country",
    pack: "Pack",
    shelfLife: "Shelf Life",
    storageCondition: "Storage Condition",
    family: "Product Family",
    phase: "Product Phase",
    category: "Product Category",
    type: "Product Type",
    subcategory: "Product Subcategory",
    name: "Product Name",
    birthdate: "International Birthdate",
    businessunit: "Business Unit",
    studyNumber: "Study Number",
    studyDescription: "Study Description",
    studyApprovalDate: "Study Approval Date",
    productsDes: "Product information",
    showActive: "Show Active",
    showInactive: "Show Inactive",
    showDisabled: "Show Disabled",
    reasonForDisable: "Reason for Disable",
    comment: "Comment",
    disableProduct: "Disable Product",
    disableProductTitle: "Are you sure you want to make the record disabled?",
    disableProductSuccessTip: "Disable the record successfully.",
    disableProductHaveDependency:
      '<p class="m-t--10 text-left">The selected product <b>cannot be disabled</b> as it is used for following RTQs, please remove the dependency.</p>',

    recordExistsTip: "Record already exists. Please enter a different record",
    updateProductSuccessTip: "Product updated successfully.",
    createProductSuccessTip: "Product created successfully.",

    updateObligationSuccessTip: "Obligation updated successfully.",
    createObligationSuccessTip: "Obligation created successfully.",

    updateLocalChangesSuccessTip: "Local Updates updated successfully.",

    updateCommitmentSuccessTip: "Commitment updated successfully.",
    createCommitmentSuccessTip: "Commitment created successfully.",
    reasonForInactive: "Reason for Inactive",
    productCategory: "Product Category",
    productSubcategory: "Product Subcategory",
    productType: "Product Type",
    productFamilyCode: "Product Family Code",
    productName: "Product Name",
    pharmaceuticalDoseForm: "Pharmaceutical Dose Form",
    therapeuticArea: "Therapeutic Area",
    productStatus: "Product Status",
    productStatusDate: "Product Status Date",
    description: "Description",
    comments: "Comments",

    addIncludeProducts: "Add Include Products",
    composition: "Composition",
    ingredient: "Ingredient",
    ingredientQuantity: "Ingredient Quantity",
    businessRule: "Business Rule",
    compositionCategory: "Composition Category",
    documents: "Documents",
    document: {
      chooseFile: "Choose File",
      switchRadioButton:
        "Moving between the radio buttons will lead to loss of the data",
      deleteDocumentSuccessTip: "Document deleted successfully.",
      updateDocumentSuccessTip: "Document updated successfully.",
      addDocumentSuccessTip: "Document added successfully.",
      editDocument: "Edit Document",
      addDocument: "Add Document",
      documentURL: "Document URL",
      uploadFromLocal: "Upload from Local",
      documentNumber: "Document Number",
      documentName: "Document Name",
      documentId: "Document ID",
      documentType: "Document Type",
      versionDate: "Version Date",
      version: "Version",
      url: "URL",
      confirmDeleteDocument: "Are you sure you want to delete this Document?",
      allowedFileTypes:
        '<b>Note</b> : Allowed File Types "<b>.doc, docx, .pdf, jpeg, .xlsx</b>", Max size: <b>5MB</b>',
    },
    file: {
      uploadFileSuccessTip: "File uploaded successfully.",
    },
  },
  validation: {
    isRequired: "is required",
    stringTooShortTip: 'The input characters must be at least {{number}}',
    stringTooLongTip: 'The input exceeds the maximum limit of {{number}}',
    regexErrorTip: 'Please Enter A Valid Format',
    numberTooSmallTip: 'The value must be greater than {{number}}',
    numberTooSmallCanEqualTip: 'The value must be greater than or equal to {{number}}',
    numberTooBigTip: 'The value must be less than {{number}}',
    numberTooBigCanEqualTip: 'The value must be less than or equal to {{number}}',
    dateTooEarlyTip: 'The selected date must be later than {{date}}',
    dateTooLateTip: 'The selected date must be earlier than {{date}}',
  },
  dynamicForm: {
    PSURReportableEvent: "PSUR Reportable Event",
    recurrence: "Recurrence",
    PSURCode: "PSUR Code",
    recurrenceFrequency: "Recurrence Frequency",
  },
  recurrence: {
    recurrenceSetup: "Recurrence Setup",
    reOccurrence: "Re-occurrence",
    notConfigured: "Recurrence is not configured for the obligations in this submission.",
    patternSection: "Recurrence Pattern",
    rangeSection: "Range of Recurrence",
    fromDate: "From Date",
    endBy: "End By",
    endAfter: "End After",
    occurrencesLabel: "occurrences",
    previewTitle: "Preview",
    taskProgressTitle: "Creating obligations",
    taskProgressLabel: "Created {{created}} / {{total}}",
    taskProgressHint: "Please wait while obligations are being created.",
    taskInProgressTitle: "Saving recurrence",
    taskInProgressLabel: "Your recurrence changes are being processed.",
    taskInProgressHint: "Please wait. This may take a few minutes.",
    pattern: {
      monthly: "Monthly",
      yearly: "Yearly",
      onObligationCompletion: "On Obligation Completion",
    },
    monthly: {
      dayOfMonthPrefix: "Day",
      everyMonthsSuffix: "of every",
      monthsLabel: "month(s)",
      thePrefix: "The",
    },
    yearly: {
      every: "Recur every",
      years: "year(s)",
      on: "On",
      onThe: "On the",
      of: "of",
    },
    completion: {
      version: "Version",
      lifecycleStage: "Lifecycle Stage",
    },
    placeholder: {
      selectDay: "Select day",
      selectMonth: "Select month",
      selectOrdinal: "Select ordinal",
      selectWeekday: "Select weekday",
      selectValue: "Select value",
    },
    previewTable: {
      recordId: "Record ID",
      obligationTitle: "Obligation Title",
      dueDate: "Obligation Due Date",
      groupId: "Group ID",
      lifecycleStage: "Lifecycle Stages",
      empty: "No occurrences to preview.",
      summary: "Total: {{total}} occurrences · {{from}}–{{to}} of {{total}}",
      rowsPerPage: "Rows per page:",
      exceedsMax:
        "This recurrence will create {{total}} obligations. A maximum of {{max}} is allowed. Adjust the date range, occurrence count.",
      exceedsMaxOverLimit:
        "This recurrence will create more than {{limit}} obligations. A maximum of {{max}} is allowed. Adjust the date range, occurrence count.",
      exceedsDateLimit:
        "This recurrence reaches the maximum supported date, {{maxDate}}. Preview only includes obligations due on or before {{maxDate}}. Reduce the occurrence count or adjust the recurrence settings.",
      monthDayFallbackNotice:
        "Some months have fewer than {{day}} days. For these months, the occurrence will fall on the last day of the month.",
      yearlyLeapDayFallbackNotice:
        "Some years do not have February 29. For these years, the occurrence will fall on February 28.",
    },
    ordinal: {
      First: "First",
      Second: "Second",
      Third: "Third",
      Fourth: "Fourth",
      Last: "Last",
    },
    weekday: {
      Sunday: "Sunday",
      Monday: "Monday",
      Tuesday: "Tuesday",
      Wednesday: "Wednesday",
      Thursday: "Thursday",
      Friday: "Friday",
      Saturday: "Saturday",
    },
    month: {
      January: "January",
      February: "February",
      March: "March",
      April: "April",
      May: "May",
      June: "June",
      July: "July",
      August: "August",
      September: "September",
      October: "October",
      November: "November",
      December: "December",
    },
    validation: {
      invalid: "Please complete all recurrence fields.",
      completionValueRequired: "Please select a version or lifecycle stage.",
      fromDateRequired: "From Date is required.",
      fromDateInvalid: "From Date is invalid.",
      endDateRequired: "End Date is required.",
      endDateInvalid: "End Date is invalid.",
      endBeforeStart: "End Date must be on or after the from Date.",
      occurrenceCountInvalid: "Occurrence count must be a positive integer.",
      occurrenceCountMax: "Occurrence count cannot exceed 100.",
      previewEmpty:
        "No obligations would be generated with the current recurrence settings. Adjust the date range, occurrence count, or recurrence pattern and try again.",
      previewExceedsMax:
        "Cannot save: this recurrence would create {{total}} obligations. Reduce the total to 100 or fewer, then try again.",
      previewExceedsMaxOverLimit:
        "Cannot save: this recurrence would create more than {{limit}} obligations. Reduce the total to 100 or fewer, then try again.",
      previewExceedsDateLimit:
        "Cannot save: this recurrence would generate obligations after {{maxDate}}. Please adjust the occurrence count or recurrence settings and try again.",
      fromDateMax: "From Date cannot be after {{maxDate}}.",
      endDateMax: "End Date cannot be after {{maxDate}}.",
      dayOfMonthInvalid: "Day of month is invalid.",
      intervalMonthsInvalid: "Month interval must be a positive integer.",
      monthWeekRequired: "Please select week ordinal and weekday.",
      intervalYearsInvalid: "Year interval must be a positive integer.",
      yearlyMonthRequired: "Please select a month.",
      yearlyDayInvalid: "Day is invalid for the selected month.",
      yearlyWeekRequired: "Please select week ordinal and weekday.",
    },
    menuAction: "Recurrence",
    modify: {
      dialogTitle: "Configure Recurrence",
      addDialogTitle: "Add Recurrence",
      updateDialogTitle: "Update Recurrence",
      groupIdLabel: "Group ID",
      pendingGroupId: "(assigned on save)",
      previewHint:
        "Past locked; Future = positional align (Update / Create / Delete surplus — red rows need Confirm)",
      lockedOccurrenceWarning:
        "Invalid recurrence configuration: this series has {{lockedCount}} locked record(s) that count toward occurrences. Occurrences must be greater than or equal to {{lockedCount}}.",
      deleteProtectedWarning:
        "{{count}} protected record(s) cannot be deleted. Adjust the recurrence configuration and try again.",
      updateProtectedWarning:
        "This series contains {{count}} protected record(s) that cannot be modified. Saving recurrence changes is not allowed.",
      previewEmptyAfterDelete:
        "Cannot save: no obligations would remain after the records marked for deletion are removed. Adjust the recurrence settings and try again.",
      fromDateBeforeToday:
        "Please change From Date to today or a future date before saving.",
      lockedLabel: "locked",
      notDeletableTooltip: "This record cannot be deleted.",
      saveSuccess: "Recurrence settings saved successfully.",
      permissionDenied: "You do not have permission to save recurrence settings.",
      concurrentEdit:
        "This series was modified by another user. Please refresh and try again.",
    },
    delete: {
      thisRecord: "Delete this record",
      series: "Delete recurrence series",
      noFutureMembers: "No future obligations to delete in this series.",
      protectedWarning: "{{count}} protected record(s) cannot be deleted.",
      seriesSuccess: "Future recurrence obligations deleted successfully.",
    },
    confirm: {
      title: "Confirm recurrence changes",
      rangeShorten:
        "The following {{deleteCount}} future record(s) will be deleted. Continue?",
      patternSwitch:
        "Changing pattern will delete {{deleteCount}} future record(s) and create {{createCount}} new record(s). Continue?",
      switchToCompletion:
        "Switching to 'On Obligation Completion' will delete all {{deleteCount}} future record(s). Future obligations will be generated one by one upon completion. Continue?",
      deleteSeries:
        "The following {{deleteCount}} future record(s) in this series will be deleted. Past records are not affected. Continue?",
    },
  },
  lcm: {
    lcm: "LCM",
    updateRegulatoryStatusSuccess: "Update regulatory status successfully.",
    commitmentInformation: "Commitment Information",
    obligationInformation: "Obligation Information",
    localUpdateInformation: "Local Update Information",
    obligations: "Obligations",
    obligation: "Obligation",
    commitments: "Commitments",
    commitment: "Commitment",
    criteria: "Criteria",
    changes: "Changes",
    change: "Change",
    selectRecords: "Select Records",
    localChanges: "Local Changes",
    localChange: "Local Change",
    localUpdates: "Local Updates",
    localUpdate: "Local Update",
    localUpdateTitle: "Local Update Title",
    localUpdateDescription: "Local Update Description",
    localUpdateCategory: "Local Update Category",
    localUpdateType: "Local Update Type",
    localUpdateSubtype: "Local Update Subtype",
    targetSubmissionDate: "Target Submission Date",
    targetImplementationDate: "Target Implementation Date",
    createSeparateLocalUpdates: "Create separate Local Updates",
    applicationAndregistration: "Applications/Registrations",
    procedureType: "Procedure Type",
    region: "Region",
    workflow: "workflow",
    metaDataStatus: "Metadata Status",
    version: "Version",
    pleaseAddChange: "please add a change",
    scopeOfLinkedRecords: "Scope of Linked Records",
    selectImpactedRecords: "Select Impacted Records",
    selectImpactedRecordsBeforeAction:
      "Please select one or more records in Impacted Records before continuing.",
    localUpdateDetails: "Local Update Details",
    basicInformationDetail: "Basic Information Detail",
    groupProcedureSelection: "Group Procedure Selection",
    groupProcedureSelectionConfirm:
      "The selected registration(s) is part of group procedure. All registrations related to this group procedure will be automatically included in this record.",
    recordName: "Record Name",
    typeofAssociation: "Type Of Association",
    recordDeleteTip:
      "Record <b>cannot be deleted </b> because it has the below dependencies.",
    recordEditTip:
      "This {{name}} is currently being used in other records, Are you sure you want to proceed?",
    saveTip: "Create multiple {{displayName}} when Saved",
    filedRequiredTemplate: "{{fieldMenu}} {{fieldName}} is required",
    category: "Category",
    type: "Type",
    subType: "Subtype",
    title: "Title",
    updateRegistration: "Update Registration",
    manage: "Manage",
    updateObligationLifeCSuccessTip:
      "The Obligation's lifecycle status has been updated.",
    updateCommitmentLifeCSuccessTip:
      "The Commitment's lifecycle status has been updated.",
    updateLocalUpdateLifeCSuccessTip:
      "The Local update's lifecycle status has been updated.",
    lifecycleCloneTaskStarted:
      "A background clone is running for this lifecycle update. We'll notify you when it finishes.",
    identifiers: {
      title: "Manage Identifiers",
      updateSuccessTip: "Identifiers Updated Successfully!",
      updateSuccessTipWithNumber:
        "{{successCount}} out of {{allCount}} record(s) updated successfully!",
      selectAllProcessingTip:
        "This operation involves a large amount of data. The system is processing it in the background and the changes will take effect shortly.",
    },
    impactedRecords: "Impacted Records",
    menuSelectedCount: "{{count}} selected in this category",
    menuTotalCount: "{{count}} impacted record(s) in this category",
    detail: "Details"
  },
  filter: {
    event: {
      label: "Events"
    }
  },
  audit: {
    entityIdentifier: "Entity Identifier",
    auditIdentifier: "Audit Identifier",
    entityName: "Entity Name",
    entityCreatedDate: "Created Date and Time",
    entityModifiedDate: "Modified Date and Time",
    fieldName: "Field Name",
    beforeModification: "Before Modification",
    afterModification: "After Modification",
    operationType: "Operation Type",
    operationDate: "Operation Date and Time",
    note: "Note: This table only contains the fields which were updated during this transaction",
    audit: "Audit",
  },
  obligation: {
    addObligation: "Add Obligation",
    addObligations: "Add Obligations",
    edit: "Edit Obligation",
    basicInfoDetails: "Basic Information Details",
    viewInfo: "View Obligation Information",
    editInfo: "Edit Obligation Information",
    updateObligationSuccess:
      "The obligation's lifecycle status has been updated.",
  },
  commitment: {
    viewInfo: "View Commitment Information",
    editInfo: "Edit Commitment Information",
    updateCommitmentSuccess:
      "The commitment's lifecycle status has been updated.",
  },
  localUpdate: {
    add: "Add Local Update",
    edit: "Edit Local Update",
    view: "View Local Update",
    registrationUpdate: "Registration Update",
    registrationInfo: "Registration Information",
    syncRegistrationData: "Sync Registration Data",
    syncAndClose: "Sync & Close",
    updateAssociationTip: "Select a section to update association",
    viewAssociationTip: "Select a section to view association",
    selectSectionTip: "Select a section to edit/add",
    viewSelectSectionTip: "Select a section to view",
    existingAssociation: "Existing Association",
    associationChanges: "Association Changes",
    draftChanges: "{{count}} Draft Change(s)",
    addInfo: "Add Information",
    editInfo: "Edit Information",
    inProgress: "In Progress",
    completed: "Completed",
    batchUpdateConfirm:
      "Do you want to apply the selected Local Updates to the registrations?",
    updateConfirm:
      "There may be some conflicts between local updates. Do you want to review it before updating?",
    selectSameRegistrationTip:
      "You cannot select the same registration record multiple times in a bulk update.",
    tip: {
      associationChangeSuccess:
        // "{{section}} association changes saved successfully",
        "Product association changes saved successfully.",
      registrationUpdateSuccess:
        "Registration {{recordID}} has been updated successfully.",
      registrationsUpdateSuccess:
        "Registrations {{recordID}} have been updated successfully.",
    },
    enterKeyToSearch: "Enter keywords to search",
    updateLocalUpdateSuccess:
      "The local update's lifecycle status has been updated.",
  },
  impactAssessment: {
    add: "Add Impact Assessment",
  },
  dynamicModule: {
    addTriggers: "Add Triggers",
  },
  globalSearch: {
    subType: "SubType",
    type: "Type",
    category: "Category",
    referenceRecord: "Reference Record",
    impactedRecord: "Impacted Record",
    workflow: "Workflow",
    filterBy: "Filter by",
  },
  registration: {
    updateInfo: "Update Registration Information",
    conflictMsg:
      "There is a conflict for this change, do you want to update with the latest draft?",
    manageUpdate: "Manage Update",
    editRecord: "Select a record to Edit",
    updateSuccess: "{{menuName}} saved successfully.",
    saveAndCloseSuccessTip: "Registration information updated successfully.",
    saveWithoutAnyChange: "The latest data has been synced from Registration.",
    existing: "Existing",
    new: "New",
  },
  popup: {
    unSaveChanges: "Unsaved Changes",
    unSaveChangesConfirm: "You have unsaved changes. Do you want to save them before you leave?",
    lackProductPrivilege: "You lack the required data privileges for Product <bold>{{productName}}</bold> to perform this operation.",
    fieldChange: "Configuration Rule Updated by Admin – Affected Fields Listed Below:",
    fieldChangeTip: "New values have been automatically rendered on the page in accordance with the updated Configuration Rule."
  },
  workflow: {
    workflowLabel: "Workflow",
    reAssociateProcess: "Re-associate",
    associateProcess: "Associate Process",
    initiateProcess: "Initiate Process",
    viewProcess: "View Process",
    terminateProcess: "Terminate Process",
    end: "End",
    endProcess: "End Process",
    task: "Task",
    instructions: "Instructions",
    Completed: "Complete Task",
    Rejected: "Reject Task",
    completeTask: "Complete Task",
    rejectTask: "Reject Task",
    recallTask: "Recall Task",
    recall: "Recall",
    complete: "Complete",
    reject: "Reject",
    process:'Process',
    due:'Due',
    overDue:'Overdue',
    actionSuccessfully:'{{actionLabel}} successfully',
    associatedSuccessfully: "Process associated successfully",
    initiatedSuccessfully: "Process initiated successfully",
    nextStepSuccessfully: "Task completed successfully",
    recallStepSuccessfully: "Task recalled successfully",
    rejectStepSuccessfully: "Task rejected successfully",
    terminateProcessSuccessfully: "Process ended successfully",
    needTerminateFirst:
      "A process is already associated with this product. Would you like to end it and re-associate?",
    lifecycleInProgress:'Lifecycle workflow is in progress. Process template cannot be associated or initiated.',
  },
};
